module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Wirehead Arts Link Tree","short_name":"wireheadarts","start_url":"/","background_color":"#476284","theme_color":"#476284","display":"minimal-ui","icon":"src/images/w-a-400.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
